import { Controller } from "@hotwired/stimulus"

// Pulsante a due stati (Radix Toggle).
export default class extends Controller {
  toggle() {
    const on = this.element.dataset.state !== "on"
    this.element.dataset.state = on ? "on" : "off"
    this.element.setAttribute("aria-pressed", String(on))
    this.dispatch("change", { detail: { pressed: on } })
  }
}
